const styles = (theme) => ({
  button: {
    marginRight: "10px",
    minWidth: "135px",
    "&$disabledButton": {
      backgroundColor: theme.headerIconColor,
      color: theme.TextColor,
    },
  },
  disabledButton: {},
  closeIcon: {
    fontSize: 24,
  },
  backButton: {
    marginRight: "10px",
  },
  completed: {
    display: "inline-block",
  },
  instructions: {
    marginTop: "10px",
    marginBottom: "10px",
    flexGrow: 1,
    minHeight:0
  },
  dialogContent: {
    fontSize: theme.headerTextFontSize,
    color: theme.TextColor,
    padding: "2 0 4 0",
    width: "100%",
    height: "100%",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },
  dialog: {
    padding: "18px 24px",
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    userSelect: "none",
    fontWeight: "600",
    minWidth: "80%",
    maxWidth: "80%",
    height: "100%",
  },
  dialogAction: {
    justifyContent: "space-between",
    margin: 0,
    "&$actionButton": {
      paddingBottom: 0,
      paddingRight: 0,
    },
  },
  actionButton: {
    margin: 0,
    padding: 0,
    display: "flex",
    justifyContent: "flex-end",
  },
  closeButton: {
    padding: 0,
    color: theme.iconColor,
  },
  circularProgress: {
    color: "white",
  },
  noPadding: {
    padding: "0px",
  },
  closeBtn: { display: "flex", justifyContent: "flex-end" },
  labelStyle: {
    color: theme.iconColor,
    fontWeight: "600 !important",
    fontSize: theme.headerTextFontSize,
  },
  activeLabelStyle: {
    color: `${theme.HeaderSelectedText} !important`,
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
  },
  rootstep: {
    backgroundColor: theme.ModalBGColor,
    padding: 0,
    paddingBottom : 12,
    width: "100%",
  },
  dialogWrapper: {},
  stepIconStyle: {
    width: "24px",
    height: "24px",
    fontWeight: 600,
  },
  infoIcon: {
    height: "20px",
    width: "20px",
    color: "#36B5B2",
  },
  stepperStyle: {
    display: "flex",
    width: "100%",
    alignItems: "baseline",
  },
});

export default styles;
